export default "__VITE_ASSET__eLQ1lCwj__"